import React from 'react';
import { theme } from 'theme';
import { Card, Grid, styled } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { SdmTypography } from 'components';
import { format, intlFormat } from 'date-fns';
import { slotStatus } from 'utils/constants';
import { useDataHelper } from 'utils/dataHelper';

const StyledCard = styled(Card)(({ isSmDown }) => ({
  backgroundColor: theme.colors.primary.white,
  borderLeft: `${isSmDown ? 5 : 10}px solid ${theme.colors.primary.red}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: isSmDown ? 5 : 10,
  marginBottom: 16,
  borderRadius: 0,
  height: 152,
}));

const ActionLink = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  cursor: 'pointer',
});

const AppointmentCard = ({
  appointment,
  isSmDown,
  isXsDown,
  i18n,
  locale,
  onView,
}) => {
  const dataHelper = useDataHelper();
  const handleView = () => onView?.(appointment);

  const date = intlFormat(
    new Date(appointment?.slot.start),
    {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
    {
      locale: dataHelper.getLangCode(locale),
    }
  );
  return (
    <StyledCard isSmDown={isSmDown}>
      <Grid container alignItems={'center'}>
        <Grid item md={4} sm={3} xs={6}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <SdmTypography
              variant={isXsDown ? 'text' : 'h2Regular'}
              style={{
                width: '100%',
                color: theme.colors.primary.black,
              }}
            >
              {appointment.brandName}
            </SdmTypography>
          </div>
        </Grid>
        <Grid item md={5} sm={6} xs={6}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 20,
            }}
          >
            <SdmTypography
              variant={isXsDown ? 'text' : 'h2Regular'}
              style={{
                width: '100%',
                color: theme.colors.primary.black,
              }}
            >
              {date}
            </SdmTypography>
            <SdmTypography
              variant={isXsDown ? 'text' : 'h2Regular'}
              style={{
                width: '100%',
                color: theme.colors.primary.black,
              }}
            >
              {format(new Date(appointment.slot.start), 'HH:mm')}-
              {format(new Date(appointment.slot.end), 'HH:mm')}
            </SdmTypography>
          </div>
        </Grid>
        <Grid item md={3} sm={3} xs={12}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              justifyContent: isSmDown ? 'center' : 'flex-end',
              flexWrap: 'wrap',
              marginTop: isXsDown ? 20 : 0,
            }}
          >
            <ActionLink onClick={() => handleView()}>
              <VisibilityIcon
                style={{
                  color: theme.colors.primary.red,
                  marginRight: 8,
                }}
              />
              <SdmTypography
                variant={'h4Regular'}
                margin={0}
                style={{
                  color: theme.colors.primary.red,
                  marginTop: 3,
                }}
              >
                {i18n.view}
              </SdmTypography>
            </ActionLink>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                gap: 5,
              }}
            >
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 50,
                  backgroundColor:
                    appointment.status === slotStatus.PENDING
                      ? theme.colors.primary.red
                      : '#0C9100',
                }}
              ></div>
              <SdmTypography
                variant={'h4Regular'}
                margin={0}
                style={{
                  color:
                    appointment.status === slotStatus.PENDING
                      ? theme.colors.primary.red
                      : '#0C9100',
                  marginTop: 3,
                }}
              >
                {appointment.status === slotStatus.PENDING
                  ? i18n.pending
                  : i18n.confirmed}
              </SdmTypography>
            </div>
          </div>
        </Grid>
      </Grid>
    </StyledCard>
  );
};
export default AppointmentCard;
